export default __webpack_public_path__ + "static/media/biking-v2.ac302504.jpg";